<template>
  <div class="notice-detail">
    <div class="detail-content">
      <template v-if="hasPermission">
        <div class="card">
          <div class="title">
            报警信息
            <div class="status-tag tag-primary" v-if="data.disposeStage == 1">待处理</div>
            <div class="status-tag tag-primary" v-if="data.disposeStage == 2">待验收</div>
            <div class="status-tag tag-success" v-if="data.disposeStage == 3">已完结</div>
          </div>
          <div class="avatar" v-if="data.type == 10 || data.signAvatar || data.type == 9">
            <img class="avatar-img" v-if="changeImgOrVideo == 1" :src="data.signAvatar || (data.type == 10 && qiling) || (data.type == 9 && fire)" alt="" @click="previewImg(data.signAvatar || qiling)" />

            <div class="avatar" v-if="isShowBackVideo && changeImgOrVideo == 2">
              <!-- <img v-if="!isShowBackVideo" :src="data.signAvatar || qiling" alt="" @click="previewImg(data.signAvatar || qiling)" /> -->
              <div class="video">
                <div id="mse1"></div>
              </div>
            </div>
          </div>

          <!-- 切换报警图片和报警视频 -->
          <div v-if="isShowBackVideo && data.type != 10 && data.type != 2">
            <div class="img-video-button" :class="{ active: changeImgOrVideo != 1 }" @click="handleClickChangeImgOrVideo">
              <van-icon name="video" color="#0065e1" v-if="changeImgOrVideo == 1" />
              <van-icon name="photo" color="#ffffff" v-else />

              {{ changeImgOrVideo == 1 ? '点击查看报警回放' : '点击查看报警图片' }}
            </div>
            <!-- <van-button size="small" :icon="changeImgOrVideo == 1 ? 'video' : 'photo'" style="width: 65%;" round type="info">{{ changeImgOrVideo == 1 ? '点击查看报警回放' : '点击查看报警图片' }}</van-button> -->
          </div>

          <div class="group">
            <div class="cell">
              <label>报警类型</label>
              <span>{{ data.typeName || '暂无报警类型' }}</span>
            </div>
            <div class="cell">
              <label>报警等级</label>
              <span>{{ data.level ? ['', '一级（重大风险）', '二级（较大风险）', '三级（一般风险）', '四级（低风险）'][data.level] : '暂无报警等级' }}</span>
            </div>
            <div class="cell">
              <label>报警地点</label>
              <span>{{ data.location || '暂无报警地点' }}</span>
            </div>
            <div class="cell">
              <label>报警时间</label>
              <span>{{ data.warningBeginTime || '暂无报警时间' }}</span>
            </div>
            <div class="cell" style="display: flex">
              <label style="display: inline-block">报警描述</label>
              <span style="display: inline-block; flex: 1">
                {{
                  (data.warningInfo &&
                    data.warningInfo
                      .split('')
                      .filter(item => item != '疑' && item != '似')
                      .join('')) ||
                    '暂无报警描述'
                }}
              </span>
            </div>
            <!-- 处理分类 -->
            <div class="cell" v-if="data.audioUrl != null">
              <audio class="success" :src="data.audioUrl" controls>
                您的浏览器不支持 audio 标签
              </audio>
            </div>
          </div>
        </div>

        <div class="card" v-if="data.solveLogVMs && data.solveLogVMs.length > 0">
          <div class="center_title">
            处理流程
          </div>
          <div class="split_line"></div>
          <div>
            <div class="process-item" v-for="(item, index) in data.solveLogVMs" :key="index">
              <div class="item-top">
                <div class="top-left">
                  <div class="dot-top"></div>
                  <div class="dot"></div>
                  <div class="dot-bottom"></div>
                </div>
                <div class="top-right">
                  <div class="title-left">
                    <template v-if="item.processType == 1">
                      <div class="process-type type-primary">发生</div>
                      <div class="operator">
                        <template>
                          <span>{{ data.typeName }}</span>
                        </template>
                      </div>
                    </template>
                    <template v-if="item.processType == 3">
                      <div class="process-type type-primary">处理</div>
                      <div class="operator" v-if="!!item.handlePersonDept || !!item.handlePersonName">
                        <template>
                          <span>{{ item.handlePersonDept ? item.handlePersonName + ' - ' + item.handlePersonDept : item.handlePersonName }}</span>
                        </template>
                      </div>
                    </template>
                    <template v-if="item.processType == 4">
                      <div class="process-type type-primary">验收</div>
                      <div class="operator" v-if="!!item.handlePersonDept || !!item.handlePersonName">
                        <template>
                          <span>{{ item.handlePersonDept ? item.handlePersonName + ' - ' + item.handlePersonDept : item.handlePersonName }}</span>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div class="title-right">
                    <!-- <template v-if="item.processType == 1"> -->
                    <div class="operator-timer" v-if="item.createdTime">
                      {{ formData(item.createdTime) }}
                    </div>
                    <!-- </template> -->
                  </div>
                </div>
              </div>
              <div class="item-bottom">
                <div class="bottom-left">
                  <div class="bottom-line"></div>
                </div>
                <div class="bottom-right">
                  <div class="process-content" v-if="item.processType == 3">
                    <div class="process-form-item" style="align-items: center">
                      <div class="process-form-label">处理结果</div>
                      <div class="process-form-content">
                        <div class="result-tag zhenshi active" v-if="item.examineResult == 1">真 实</div>
                        <div class="result-tag xunjian active" v-if="item.examineResult == 2">巡 检</div>
                        <div class="result-tag wubao active" v-if="item.examineResult == 3">误 报</div>
                      </div>
                    </div>
                    <div class="process-form-item">
                      <div class="process-form-label">处理情况</div>
                      <div class="process-form-content">
                        {{ item.handleOpinion }}
                      </div>
                    </div>
                    <div class="process-form-item">
                      <div class="process-form-label">处理照片</div>
                      <div class="process-form-content">
                        <div style="display: flex; flex-wrap: wrap; gap:0.38rem" v-if="item.disposeImg">
                          <div v-for="(photo, photoIndex) in item.disposeImg" :key="photoIndex" class="image-item">
                            <!-- <AjImage :src="photo" :index="photoIndex" :imageList="item.disposeImg || []"></AjImage> -->
                            <img class="item_avatar" @click="previewImg2(photoIndex, item.disposeImg)" :src="photo.tempFilePath" alt="" style="object-fit: cover;height: 100%;width: 100%;" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="process-content" v-if="item.processType == 4">
                    <div class="process-form-item">
                      <div class="process-form-label">验收情况</div>
                      <div class="process-form-content">
                        {{ item.examineResult == 1 ? '通过' : '驳回' }}
                      </div>
                    </div>
                    <div class="process-form-item">
                      <div class="process-form-label">验收意见</div>
                      <div class="process-form-content">
                        {{ item.handleOpinion }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-permission">
          <div>
            <img src="@/assets/noper.png" alt="" />
            <div>您没有权限查看该报警消息</div>
          </div>
        </div>
      </template>
    </div>
    
    <!-- 汉峪 gh_4316d11def57-->
    <!-- 彩虹湖 gh_0d2f5e791fbc-->

    <!-- 开放标签1跳转报警小程序 汉裕 -->
    <!-- <div style="text-align: center;padding: 12px;background-color: #fff;"   v-if="data.disposeStage == 1 && pageType == 'dispose'">
      <wx-open-launch-weapp id="jump_btn" :path="path" username="gh_0d2f5e791fbc">
        <script type="text/wxtag-template">
          <style>
              .btn {
                  display: inline-block;
                  width: 15rem;
                  padding: 0.5rem 0;
                  margin: 0 auto;
                  background: #37a5da;
                  font-size: 1rem;
                  border: none;
                  border-radius: 1rem;
                  text-align: center;
                  color: #fff;
                  borer-style:none;
              }
            </style>
              <div class="btn" @click="test">处理</div>
            </script>
      </wx-open-launch-weapp>
    </div> -->


    <!-- <div style="text-align: center;padding: 12px;background-color: #fff;" v-if="data.disposeStage == 2 && pageType == 'acceptance'">
      <wx-open-launch-weapp id="jump_btn" :path="path" username="gh_0d2f5e791fbc">
        <script type="text/wxtag-template">
          <style>
              .btn {
                  display: inline-block;
                  width: 15rem;
                  padding: 0.5rem 0;
                  margin: 0 auto;
                  background: #37a5da;
                  font-size: 1rem;
                  border: none;
                  border-radius: 1rem;
                  text-align: center;
                  color: #fff;
                  borer-style:none;
              }
            </style>
              <div class="btn" @click="test">验收</div>
            </script>
      </wx-open-launch-weapp>
    </div> -->


    <!-- 使用开放标签跳转微信小程序 -->
    <!-- <wx-open-launch-weapp id="launch-btn" username="gh_183e21fd1dda" path="/pages/login/login">
     
      <div 
      style="width: 15rem;padding: 0.5rem 0;margin: 0 auto;background-color: #37a5da;border-radius: 1rem;color: #fff;text-align:center;"
      >
      处理
      </div>
    </wx-open-launch-weapp> -->
  </div>
</template>

<script>
import moment, { now } from "moment";
import Player from 'xgplayer'
import 'xgplayer/dist/index.min.css';
import { ImagePreview } from "vant";
import store from "../../store";
export default {
  name: "notice-detail",
  data() {
    return {
      hasPermission: true,
      signAvatar: "",
      list: [],
      data: {},
      pageType: 'detail',
      // 切换展示报警图片和报警视频
      changeImgOrVideo: 1,
      qiling: require("@/assets/qiling.webp"),
      fire: require('@/assets/fire_alarm.webp'),
      // 是否显示回放视频
      isShowBackVideo: false,
      // 测试 
      index: 0,
      path: '',
      timer: '',
      // 当前时间3分钟后的时间
      nowAfter: moment().add(3, 'm').format('YYYY-MM-DD HH:mm:ss')
    };
  },
  created() {
    this.getNoticeDetail();
  },
  mounted() {
    this.initWXConfig();
    this.pageType = this.$route.query.pageType;
    this.getNoticeDetail();
    // this.timer = setInterval(() => {
    //   console.log('进来了吗')
    //   this.index = this.index + 1
    //   this.getNoticeDetail()
    // }, 3000)
  },
  methods: {
    previewImg2(index, list) {
      let tempList = list.map(item => {
        return item.tempFilePath;
      });
      ImagePreview({
        images: tempList,
        startPosition: index
      });
    },
    formData(time, format) {
      return moment(time).format(format || 'YYYY-MM-DD HH:mm:ss');
    },
    
    handleClickChangeImgOrVideo() {
      if (this.changeImgOrVideo == 1) {
        this.changeImgOrVideo = 2;
        setTimeout(() => {
          this.initPlayer();
        });
      } else {
        this.changeImgOrVideo = 1;
      }
    },
    // 初始化回放视频插件
    initPlayer() {
      let _this = this
      console.log('_this.data', _this.data)
      let player = new Player({
        id: 'mse1',
        url: _this.data.playbackUrl,
        poster: _this.data.signAvatar,
        videoInit: true, // 显示首帧
        width: '100%',
        height: '100%',
        cors: true, // 跨域
        playsinline: true,
      });
    },
    
    // 配置开放标签跳转
    initWXConfig() {
      this.$https
        .getWXConfig({
          appid: store.state.appId,
          url: location.href.split("#")[0],
        })
        .then((res) => {
          console.log("拿到配置结果", res);

          // 判断是否自动登录
          if (res.code == 401) {
            // if () {

            // }


          } else {
            wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp, //生成签名的时间戳
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: ["onMenuShareWeibo", "closeWindow"],
              openTagList: ["wx-open-launch-weapp"],
            });
          }

        });
        this.$nextTick(() => {
        console.log('this.data', this.data);
      });
      let handlerId = JSON.parse(localStorage.getItem('userInfo')).id;
      let handlerName = JSON.parse(localStorage.getItem('userInfo')).name;
      this.path = `pages2/selectChild/selectChildDetail/alarmDetail?id=${this.$route.query.id}&handlerId=${handlerId}&handlerName=${handlerName}&pageType=${this.$route.query.pageType}`;
    },
    // 预览图片
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        // closeOnPopstate: true,
      });
    },
     // 时间格式化
     getTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 获取报警详情
    getNoticeDetail() {
      this.axios
        .get(
          `student-consumer/api/schoolcarwarning/getSchoolCarWarningByIdMini`,
          {
            params: {
              id: this.$route.query.id,
            },
          }
        )
        .then((res) => {
          if (res.code === 202) {
            this.hasPermission = false;
          } else {
            this.hasPermission = true;
          }
          if (res.code === 200) {
            if (res.data) {



              if (res.data.playbackUrl) {
                // 判断是否为rtsp格式
                let str = res.data.playbackUrl.substring(0, 4)
                if (str != 'rtsp') {
                  this.isShowBackVideo = true
                  clearInterval(this.timer)
                  // 显示报警回放视频
                  // setTimeout(() => {
                  //   this.initPlayer()
                  // })
                }

              } else {
                // let warningAfterTime = this.nowAfter
                // let nowTime = moment().format('YYYY-MM-DD HH:mm:ss')
                // if (moment(nowTime).isBefore(warningAfterTime)) { // 当前时间在报警开始时间的3分钟以内 ，定时调用接口获取报警回放视频地址
                //   setTimeout(() => {
                //     console.log('进来了吗')
                //     // this.index += 1
                //     this.getNoticeDetail()
                //   }, 3000)
                // }
                if (this.index == 10) {
                  clearInterval(this.timer)
                  return
                }
              }


              this.data = res.data;
              // this.data.signAvatar = ''
              this.data.warningBeginTime =
                (res.data.warningBeginTime &&
                  moment(res.data.warningBeginTime).format(
                    "YYYY-MM-DD HH:mm"
                  )) ||
                "--";
            }
          } else {
            this.$toast(res.msg);
            // this.getNoticeDetail()
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scope>

.notice-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-content {
    padding: 0.8rem 0.625rem;
    flex: 1;
    overflow: auto;
  }
  .card {
    padding: 0.75rem;
    background-color: #fff;
    border-radius: 0.5rem;
    margin-bottom: 0.625rem;
    position: relative;

    .title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 0.89rem;
      position: relative;
      color: #333333;
      padding-left: 0.5rem;
      line-height: 1;
      &::before {
        content: '';
        position: absolute;
        border-radius: 0.11rem 0.11rem 0.11rem 0.11rem;
        width: 0.22rem;
        height: 0.89rem;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #0065e1;
      }
    }

    .avatar {
      padding: 0;
      .name {
        text-align: center;
        font-size: 0.75rem;
        margin-top: 0.7rem;
        color: #969799;
      }

      .video {
        width: 21rem;
        height: 12rem;
        margin: 1rem auto;
        border-radius: 0.44rem;

        #mse1 {
          border-radius: 0.44rem;
        }
      }
    }

    .avatar-img {
      width: 21rem;
      height: 12rem;
      border-radius: 0.44rem;
      margin: 1rem auto;
      display: block;
      object-fit: cover;
    }

    .group {
      margin-top: 1.33rem;
      .cell {
        display: flex;
        margin-bottom: 1.11rem;
        label {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 0.78rem;
          color: #999;
        }
        span {
          margin-left: 0.89rem;
          flex: 1;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 0.78rem;
          color: #1a1a1a;
        }
        // .span_zhenshi {
        //   background-color: #f46c6c;
        //   color: #fff;
        //   border-radius: 0.3125rem;
        //   padding: 0.1875rem 0.625rem;
        // }

        // .span_wubao {
        //   background-color: #8f939c;
        //   color: #fff;
        //   border-radius: 0.3125rem;
        //   padding: 0.1875rem 0.625rem;
        // }

        // .span_xunjian {
        //   background-color: #e6a23f;
        //   color: #fff;
        //   border-radius: 0.3125rem;
        //   padding: 0.1875rem 0.625rem;
        // }
      }
    }
  }

  .submit {
    // padding-top:10rpx;
    // padding-bottom:10rpx;
    display: block;
    width: 15rem;
    padding: 0.5rem 0;
    margin: 0 auto;
    background: #37a5da;
    font-size: 1rem;
    border-radius: 0.44rem;
    text-align: center;
    color: #fff;
  }
}

.success {
  width: 100%;
  height: 2rem;
}

.split_line {
  height: 0.06rem;
  background: #f4f4f6;
  border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
  margin-bottom: 0.78rem;
  margin-top: 0.78rem;
}
.status-tag {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.75rem;
  padding: 0.22rem 0.44rem;
  border-radius: 0.11rem;
}
.tag-primary {
  background-color: rgba(0, 101, 225, 0.1);
  color: #0065e1;
}
.tag-success {
  background-color: rgba(153, 153, 153, 0.1);
  color: #999999;
}
.tag-danger {
  background-color: rgba(241, 111, 109, 0.1);
  color: #f16f6d;
}
.img-video-button {
  font-size: 0.78rem;
  border-radius: 0.22rem 0.22rem 0.22rem 0.22rem;
  border: 0.06rem solid #0065e1;
  color: #0065e1;
  display: inline-block;
  padding: 0.5rem 1rem;
  &.active {
    color: #fff;
    background-color: #0065e1;
  }
}
.center_title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 0.89rem;
  color: #333333;
  position: relative;
  padding-left: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
  &::before {
    content: '';
    position: absolute;
    border-radius: 0.11rem 0.11rem 0.11rem 0.11rem;
    width: 0.22rem;
    height: 0.89rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: #0065e1;
  }
}

.no-permission {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  color: #8ec4fc;
  text-align: center;
  padding-bottom: 5rem;
  img {
    margin-bottom: 1rem;
    width: 15.2rem;
    height: 8rem;
  }
}
</style>
